import type { AuthErrorResponse } from '@/js/types/auth.ts';

export const FIELD_SELECTOR = '.base-field';
const INVALID_CLASS = 'base-field_state_invalid';
const SUCCESS_CLASS = 'base-field_state_success';
const DATA_MESSAGE = 'data-message';

type FieldElement = HTMLElement | null;
type FormFieldErrors = Record<string, string>;

export function showFieldError(element: FieldElement, error: string) {
  const field = element?.closest<HTMLElement>(FIELD_SELECTOR);
  if (field) {
    field.setAttribute(DATA_MESSAGE, error);
    field.classList.add(INVALID_CLASS);
  }
}

export function showFieldSuccess(element: FieldElement, text: string) {
  const field = element?.closest<HTMLElement>(FIELD_SELECTOR);
  if (field) {
    field.setAttribute(DATA_MESSAGE, text);
    field.classList.add(SUCCESS_CLASS);
  }
}

export function clearField(element: FieldElement) {
  const field = element?.closest<HTMLElement>(FIELD_SELECTOR);
  if (field) {
    field.classList.remove(INVALID_CLASS);
    field.classList.remove(SUCCESS_CLASS);
    field.removeAttribute(DATA_MESSAGE);
  }
}

export function showFormFieldErrors(form: HTMLFormElement, errors: FormFieldErrors) {
  let hasFieldErrors = false;

  for (const [fieldName, message] of Object.entries(errors)) {
    if (!message)
      continue;

    const field = form.querySelector<HTMLElement>(`[name="${fieldName}"]`);
    if (!field)
      continue;

    showFieldError(field, message);
    hasFieldErrors = true;
  }

  return hasFieldErrors;
}

export function showServerFieldErrors(form: HTMLFormElement, error: AuthErrorResponse | null) {
  const fieldErrors = Object.fromEntries(
    Object.entries(error?.errors ?? {}).map(([fieldName, messages]) => [fieldName, messages[0] ?? '']),
  );

  return showFormFieldErrors(form, fieldErrors);
}
